export const ERROR = 'error';
export const INFO = 'info';
export const VALIDATION = 'validation';